module.exports = __webpack_public_path__ + "img/trash.2108b72f.png";